import { render, staticRenderFns } from "./PortForwarding.vue?vue&type=template&id=f8d6b972&scoped=true&"
import script from "./PortForwarding.vue?vue&type=script&lang=js&"
export * from "./PortForwarding.vue?vue&type=script&lang=js&"
import style0 from "./PortForwarding.vue?vue&type=style&index=0&id=f8d6b972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d6b972",
  null
  
)

export default component.exports